module.exports = __webpack_public_path__ + "img/fzlc2022.d00488ae.png";